(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/casino/categories/assets/javascripts/categories.js') >= 0) return;  svs.modules.push('/components/casino/categories/assets/javascripts/categories.js');
"use strict";


class Categories {
  constructor(clientCasinoSection) {
    this.clientCasinoSection = clientCasinoSection;
    this.addListeners();
  }
  addListeners() {
    $('.js-casino-categories-casinosection-casino').on('click', () => this.toggleList('casino'));
    $('.js-casino-categories-casinosection-livecasino').on('click', () => this.toggleList('liveCasino'));
    $('.js-casino-categories-item').on('click', this.trackEvent);
  }
  toggleList(casinoSection) {
    var _this$clientCasinoSec, _this$clientCasinoSec2;
    $(".js-casino-categories-".concat(this.clientCasinoSection)).addClass('hide');
    $(".js-casino-categories-casinosection-".concat((_this$clientCasinoSec = this.clientCasinoSection) === null || _this$clientCasinoSec === void 0 ? void 0 : _this$clientCasinoSec.toLowerCase())).addClass('btn-transparent-default').removeClass('btn-inverted');
    this.clientCasinoSection = casinoSection;
    $(".js-casino-categories-".concat(this.clientCasinoSection)).removeClass('hide');
    $(".js-casino-categories-casinosection-".concat((_this$clientCasinoSec2 = this.clientCasinoSection) === null || _this$clientCasinoSec2 === void 0 ? void 0 : _this$clientCasinoSec2.toLowerCase())).removeClass('btn-transparent-default').addClass('btn-inverted');
  }
  trackEvent(e) {
    const title = e.currentTarget.dataset.title;
    if (title) {
      const eventData = {
        category: 'Casino',
        event: 'click',
        action: 'Categories',
        opt_label: title
      };
      svs.components.analytics.trackEvent(eventData);
    }
  }
}
setGlobal('svs.components.casino.Categories', Categories);

 })(window);